export function dataInRequest(params = {}) {
  return {
    type: '@consultaavancada/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@consultaavancada/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@consultaavancada/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@consultaavancada/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@consultaavancada/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@consultaavancada/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@consultaavancada/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@consultaavancada/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@consultaavancada/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@consultaavancada/RECORD_FILTERING',
    payload: { params },
  };
}
